import React from "react";
import { useSelector } from "react-redux";
import { AssesseDahboard } from "./AssesseDashboard";
import { AssessorDashboard } from "./AssessorDashboard";
export const Home =(props) =>{
    const loggedInUserData = useSelector((state) => { return state.user });
    console.log(loggedInUserData?.rolename)
    if(loggedInUserData?.rolename == "Assesse") {
        return(
        <AssesseDahboard history ={props.history}/>
        )
    } else {
        return(
        <AssessorDashboard  history ={props.history}/>
        )
    }
}